import React, { Component } from 'react';
import { arrayOf, bool, object, number, oneOfType, shape, string } from 'prop-types';
import { Tooltip } from 'ps-design';
import Button from 'ps-components/Button/Button';
import HeaderData from './HeaderData/HeaderData';
import './SurveyJobMatchesHeader.scss';

class SurveyJobMatchesHeader extends Component {
  static propTypes = {
    history: object,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      fileLocation: string,
      filetTitle: string,
      employeeCount: oneOfType([string, number]),
      id: oneOfType([string, number]),
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    useJobCodeKey: bool
  };

  generateTooltip = () => {
    const { selectedJob } = this.props;

    return (
      <Tooltip
        display="underline"
        hoverText={selectedJob.description}
        id={selectedJob.name}
        position="bottom"
        tooltipText={selectedJob.name}
      />
    );
  };

  openModal = () => {
    const { history, selectedJob } = this.props;

    history.push(`/market-analysis/jobs/${selectedJob.id}/edit-matches`, {
      component: 'SURVEY_JOB_MATCHING',
      modal: true,
      modalProps: { className: 'job-matching__modal', orgJob: selectedJob },
      modalType: 'SURVEY_JOB_MATCHING'
    });
  };

  render() {
    const { replacementTokens, useJobCodeKey, selectedJob } = this.props;
    const { code, codeKey, currency, description, descriptionDocument, name } = this.props.selectedJob;
    const buttonText = 'Add Matches';
    const hasJobDescription = description;
    const hadJobDescriptionDocument = descriptionDocument && descriptionDocument.fileLocation;
    const orgJobCodeKey = replacementTokens.find(value => value.token === 'job_code_key_text');
    const orgJobCodeKeyLabel = orgJobCodeKey && orgJobCodeKey.value ? orgJobCodeKey.value : 'Job Code Key';

    return (
      <div className="matches__header">
        <div className="matches__header-row">
          <div className="pxl-header-xsmall matches__name">{hasJobDescription ? this.generateTooltip() : name}</div>
        </div>
        <div className="matches__header-row">
          <div className="matches__data">
            <HeaderData className="pxl-text-xsmall" label="Job Code" value={code} />
            {useJobCodeKey && <HeaderData className="pxl-text-xsmall" label={orgJobCodeKeyLabel} value={codeKey} />}
            <HeaderData className="pxl-text-xsmall" label="Currency" value={currency} />
          </div>
          {selectedJob.jobMatches && selectedJob.jobMatches.length > 0 && (
            <Button className="matches__btn pxl-btn pxl-btn-primary pxl-btn-sm" onClick={this.openModal}>
              {buttonText}
            </Button>
          )}
        </div>
        <div className="matches__header-row">
          <div className="matches__link-container pxl-text-xsmall">
            {hadJobDescriptionDocument && (
              <a
                className="matches__link"
                href={descriptionDocument.fileLocation}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="icon-doc-text" />
                Job description
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyJobMatchesHeader;
